import Masonry from 'masonry-layout/dist/masonry.pkgd.min';

document.addEventListener('DOMContentLoaded', () => {

    if (document.querySelector('.grid-news')) {
        setTimeout(function() {
            const grid = document.querySelector('.grid-news');
            const masonry = new Masonry(grid, {
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                percentPosition: true,
                horizontalOrder: true
            });
        }, 300);
    }
});

$(document).ready(() => {

    $('.js-filter-news').click(function(e){
        e.preventDefault();
        $(this).addClass('active').siblings('.js-filter-news').removeClass('active');
        filterNews($(this));
    });

    function filterNews($el){
        let numberposts = $el.parents('.block-filter').data('numberposts');
        let page = $el.parents('.block-filter').data('page');
        let type = $el.data('type');
        $('.loader').show();
        $.ajax({
            url: myajax.url,
            dataType: 'json',
            method: 'POST',
            data: {
                action: 'filter_news',
                numberposts: numberposts,
                type: type,
                page: page
            },
            success(data) {
                let newNewsGrid = $('<div>'+data.content+'</div>');
                $el.parents('.masonry-news').find('.grid-news').html(newNewsGrid.find('.grid-news').html());
                setTimeout(function() {
                    let msnry = new Masonry( '.grid-news', {
                        itemSelector: '.grid-item',
                        columnWidth: '.grid-sizer',
                        percentPosition: true,
                        horizontalOrder: true
                    });
                }, 300);

                /*if ($event == 'load') {
                    $("html, body").animate({ scrollTop: 0 }, 600);
                }*/
            },
            complete: function(){
                $('.loader').hide();
            },
        });
    }

});
